const About = () => {
  const features = [
    {
      icon: "💡",
      title: "Innovation",
      description:
        "Cutting-edge solutions built using modern tech stacks.",
    },
    {
      icon: "🛡️",
      title: "Security",
      description:
        "Enterprise-grade security standards for data safety.",
    },
    {
      icon: "📈",
      title: "Scalability",
      description:
        "Solutions designed to grow seamlessly with your business.",
    },
    {
      icon: "🤝",
      title: "Support",
      description:
        "Dedicated technical support and continuous updates.",
    },
  ];

  return (
    <section className="py-16 lg:py-24 relative overflow-hidden bg-white text-slate-800">
      {/* Background Effects */}
      <div className="absolute top-10 left-10 w-80 h-80 bg-cyan-100/30 rounded-full blur-3xl pointer-events-none -z-10"></div>
      <div className="absolute bottom-10 right-10 w-80 h-80 bg-blue-100/30 rounded-full blur-3xl pointer-events-none -z-10"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-20">
          <h1 className="text-4xl md:text-5xl font-extrabold text-slate-900">
            About{" "}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-600 to-blue-600">
              Bytecs Technologies
            </span>
          </h1>

          <div className="h-1 w-14 bg-cyan-500 mx-auto mt-4 rounded-full"></div>

          <p className="mt-6 text-lg text-slate-600">
            Empowering businesses with innovative technology solutions,
            workforce management systems, and digital transformation services.
          </p>
        </div>

        {/* About Section */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">

          {/* Image */}
          <div className="relative group">
            <div className="absolute -inset-1 bg-gradient-to-r from-cyan-500 to-blue-500 rounded-3xl blur opacity-10 group-hover:opacity-20 transition duration-500"></div>

            <div className="relative bg-white p-2 rounded-2xl border border-slate-200 shadow-lg overflow-hidden">
              <img
                src="/about-us.png"
                alt="About Bytecs Technologies"
                className="rounded-xl w-full hover:scale-[1.02] transition duration-500"
              />
            </div>
          </div>

          {/* Content */}
          <div>
            <h2 className="text-3xl font-bold text-slate-900">
              Who We Are
            </h2>

            <div className="h-1 w-10 bg-cyan-500 rounded-full mt-4 mb-6"></div>

            <div className="space-y-5 text-slate-600">
              <p>
                Bytecs Technologies Pvt. Ltd. is a technology-driven company
                specializing in workforce management, visitor management,
                attendance tracking, security solutions, and digital business
                transformation.
              </p>

              <p>
                We help organizations streamline operations, enhance security,
                improve workforce productivity, and make smarter business
                decisions through innovative software solutions.
              </p>

              <p>
                Our mission is to simplify complex business processes using
                modern technology and deliver scalable solutions that create
                measurable business value.
              </p>
            </div>
          </div>
        </div>

        {/* Mission & Vision */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-24">

          <div className="bg-cyan-50 border border-cyan-100 p-8 rounded-2xl shadow-sm hover:shadow-lg transition">
            <div className="text-4xl mb-4">🎯</div>

            <h3 className="text-2xl font-bold text-cyan-800 mb-3">
              Our Mission
            </h3>

            <p className="text-slate-600">
              To provide innovative, secure, and reliable technology solutions
              that empower organizations to achieve operational excellence and
              sustainable growth.
            </p>
          </div>

          <div className="bg-slate-50 border border-slate-200 p-8 rounded-2xl shadow-sm hover:shadow-lg transition">
            <div className="text-4xl mb-4">👁️</div>

            <h3 className="text-2xl font-bold text-slate-800 mb-3">
              Our Vision
            </h3>

            <p className="text-slate-600">
              To become a globally recognized technology partner known for
              transforming businesses through innovation, automation, and
              intelligent digital solutions.
            </p>
          </div>
        </div>

        {/* Why Choose Us */}
        <div className="mt-28">

          <div className="text-center max-w-2xl mx-auto mb-16">
            <h2 className="text-3xl font-bold text-slate-900">
              Why Choose Us
            </h2>

            <div className="h-1 w-10 bg-cyan-500 mx-auto mt-4 rounded-full"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">

            {features.map((item, index) => (
              <div
                key={index}
                className="bg-white p-8 rounded-2xl border border-slate-100 text-center shadow-sm hover:shadow-xl hover:-translate-y-2 transition-all duration-300"
              >
                <div className="w-14 h-14 bg-cyan-50 text-cyan-600 rounded-xl flex items-center justify-center mx-auto mb-5 text-2xl">
                  {item.icon}
                </div>

                <h3 className="font-bold text-lg mb-2 text-slate-900">
                  {item.title}
                </h3>

                <p className="text-sm text-slate-500">
                  {item.description}
                </p>
              </div>
            ))}

          </div>
        </div>

      </div>
    </section>
  );
};

export default About;